import React, { Component } from 'react';

import { withDomains, RESTExecutor } from '../../../lib/domain';
import { Row, Table, Button, Input } from 'antd';
import Title from 'antd/lib/typography/Title';
import { formatMoney } from '../../../lib/util';


const aggregator_cols = ({ onEditPressed }) => [
    {
        title: "Aggregator Name",
        dataIndex: "name",
        key: 'name'
    },
    {
        title: "ID",
        dataIndex: 'id',
        key: 'id'
    },
    {
        title: "",
        dataIndex: 'id',
        key: 'action',
        render: (id, data) => <Button
            type='link'
            onClick={() => {
                typeof onEditPressed === 'function' && onEditPressed(data)
            }}>Edit</Button>

    }
]


class AggregatorsView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            form_visibility: false,
            form_data: {},
            edit_id: null
        };
        this.list_aggregators = RESTExecutor.list().config({
            label: 'aggregators'
        }).connect(props.domains.settings);

        this.post_aggregators = RESTExecutor.post().config({
            label: 'aggregators'
        }).callbacks((success) => {
            this.list_aggregators.execute();
            this.setState({
                form_visibility: false,
                form_data: {},
                edit_id: null
            })
        })
        .connect(props.domains.settings);

        this.patch_aggregator = RESTExecutor.patch().config({
            label: 'aggregators_detail'
        }).forId("").callbacks((success) => {
            this.list_aggregators.execute();
            this.setState({
                form_visibility: false,
                form_data: {},
                edit_id: null
            })
        }).connect(props.domains.settings);

    };

    handlePostPatch = (data) => {
        if (this.state.edit_id) {
            this.patch_aggregator.forId(this.state.edit_id).execute(data);
        } else {
            this.post_aggregators.execute(data);
        }
    }


    render() {
        let list_aggregators_res = this.list_aggregators.response();
        let list_aggregators_data = list_aggregators_res.result || {};
        let rowsMeta = list_aggregators_res.meta || {};

        let rowsData = list_aggregators_data.rows || [];

        let filteredData = JSON.parse(JSON.stringify(rowsData));
        if (this.state.query) {
            filteredData = filteredData.filter(({ name = "", id = "", description = "" }) => {
                name = name.toLowerCase();
                id = id.toLowerCase();
                description = description.toLowerCase();
                return name.includes(this.state.query.toLowerCase())
                    || id.includes(this.state.query.toLowerCase())
                    || description.includes(this.state.query.toLowerCase());
            });
        }


        return (
            <div>
                <Table
                scroll={{x:true}}
                    columns={aggregator_cols({
                    })}
                    pagination={{
                        showTotal:(total,range)=>`${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                        }}
                    dataSource={filteredData}
                    className='ant-table-small-noborder  '
                    size='small'
                    title={() => <div><Row type='flex' justify='space-between' style={{
                        alignItems: 'center'
                    }}><Title
                        type='secondary'
                        level={3}

                        style={{
                            margin: 0
                        }}>Aggregator List</Title>
                    </Row><br></br>
                        <Row type='flex'
                            justify='space-between'
                            style={{
                                alignItems: 'center',
                                flexWrap: 'nowrap'
                            }}>
                            <Input.Search
                                placeholder="Search For"
                                style={{
                                }}
                                value={this.state.query}
                                onChange={(e) => {
                                    this.setState({ query: e.target.value })
                                }}
                            /> {this.state.query && this.state.query.length > 0 && <Button
                                style={{
                                    marginLeft: 4
                                }}
                                type='danger'
                                shape="circle"
                                icon="close-circle"
                                onClick={() => {
                                    this.setState({ query: null })
                                }} />}
                        </Row></div>}
                    rowKey={(record) => record.id}
                />
            </div>
        );
    }

    componentDidMount() {
        this.list_aggregators.execute()
    }
}

export default withDomains(AggregatorsView, "settings");
